import React from 'react';
import { assest } from '../../Assest/Assest';

function OralSurgery() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.OralSurgery} 
        alt="Oral Surgery" 
        style={styles.image} 
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Expert Oral Surgery for Your Dental Health</h2>
        <p style={styles.text}>
          Oral surgery is a specialized branch of dentistry that focuses on diagnosing and treating complex dental issues that 
          require surgical intervention. Whether it's wisdom tooth removal, dental implants, or jaw correction, our team of 
          experienced oral surgeons provides personalized care to ensure your comfort and health.
        </p>
        <p style={styles.text}>
          Common oral surgery procedures include extractions, treatment for impacted teeth, correcting jaw alignment, and 
          addressing facial trauma. These procedures are performed using advanced technology and techniques to minimize 
          discomfort and recovery time.
        </p>
        <p style={styles.text}>
          Our clinic prioritizes your safety and well-being during every step of the process. We offer comprehensive consultations 
          to discuss your needs and create a tailored treatment plan. Let us help restore your oral health with expert care. 
          Schedule a consultation today!
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
};

export default OralSurgery;
